__webpack_require__.p = "/mkn-react-portfolio/";